import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Banner from "../components/banner"
import Cta from "../components/cta"
import CurrentPromotions from "../components/current-promotions"
import Protect from "../components/protect"

const PostTemplate = ({ location, data: { post, previous, next } }) => {
  const { title, date, uri, content, seo, featuredImage } = post
  const isPrivate = post?.frontEndVisibility?.frontEndVisibility === "private"
  const banner = {
    heading: title,
    subheading: date,
    breadcrumb: {
      title: "News",
      url: "/about/news/",
    },
    image: featuredImage?.node,
    background: "rollingHills"
  }
  const publicPrevious = previous?.frontEndVisibility?.frontEndVisibility === "private" ? null : previous
  const publicNext = next?.frontEndVisibility?.frontEndVisibility === "private" ? null : next

  return (
    <Layout uri={uri} location={location}>
      <Seo
        title={seo?.title || title}
        description={seo?.metaDesc}
        image={seo?.opengraphImage?.localFile?.publicURL}
        uri={post.uri}
        robots={isPrivate ? 'noindex, nofollow' : undefined}
      />
      {isPrivate ? (
        <Protect>
          <PostContent banner={banner} content={content} previous={publicPrevious} next={publicNext} />
        </Protect>
      ) :
        <PostContent banner={banner} content={content} previous={publicPrevious} next={publicNext} />
      }
    </Layout>
  )
}

export default PostTemplate

export const postQuery = graphql`
  query WordPressPost( 
    $id: String!
    $previousPostId: String
    $nextPostId: String
    ) {
    post: wpPost(id: { eq: $id }) {
      title
      uri
      content
      date(formatString: "MMMM D, YYYY")
      seo {
        title
        metaDesc
        opengraphImage {
          localFile {
            publicURL
          }
        }
      }
      featuredImage {
        node {
          altText
          localFile {
            publicURL
            extension
            childImageSharp {
              gatsbyImageData(width: 2560)
            }
          }  
        }
      }
      frontEndVisibility {
        frontEndVisibility
      }
    }
    previous: wpPost(id: { eq: $previousPostId }) {
      uri
      title
      frontEndVisibility {
        frontEndVisibility
      }
    }
    next: wpPost(id: { eq: $nextPostId }) {
      uri
      title
      frontEndVisibility {
        frontEndVisibility
      }
    }
  }
`


function PostContent({ banner, content, previous, next }) {
  return <>
    <Banner props={banner} index={0} />
    <div className="w-full -mt-16 pt-16 shadow-spread opacity-50" />
    <section className="py-16 bg-banner-gradient/5 xl:bg-none">
      <div className="container relative flex items-start">
        <div className="xl:col-span-2 xl:bg-banner-gradient/5 xl:px-6 xl:py-5 mr-6 2xl:mr-8 flex-grow">
          <div className="parsed-content leading-relaxed" dangerouslySetInnerHTML={{ __html: content }} />
        </div>
        <aside className="hidden xl:block sticky top-16 max-w-sm flex-shrink-0">
          <CurrentPromotions format="compact" />
        </aside>
      </div>
    </section>
    <section className="bg-banner-gradient/10 text-white links-white py-12">
      <nav className="container">
        <ul
          className="grid sm:grid-cols-2 gap-6 justify-between list-none"
        >
          {previous ? (
            <li>
              <Cta props={{ url: previous.uri, title: `← ${previous.title}` }} rel="prev" />
            </li>
          ) : (
            <li>
              <Cta props={{ url: "/about/news/", title: "← Back to News" }} />
            </li>
          )}

          {next && (
            <li className="sm:text-right sm:col-start-2">
              <Cta props={{ url: next.uri, title: `${next.title} →` }} rel="next" />
            </li>
          )}

        </ul>
      </nav>
    </section>
  </>
}

